/**
 * sessionStorage key written by the `/r/:code` redeem route when a referral
 * link is opened, consumed once by `PromoCodeInput`'s mount effect so the
 * code arrives pre-applied at checkout. `ReferralBridge` reads it too, to
 * open the subscription tab once a logged-out visitor finishes signing in.
 */
export const PENDING_REFERRAL_CODE_KEY = 'pending_referral_code';
